import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import React from "react";
import { HermesSnackbar } from "../../../components/snackbar";
import { SelectedTrip } from "../../../interfaces";
import { Permission } from "../../../literals";
import {
    ActionType,
    ResourceType,
    StatusType,
    sendLog,
} from "../../../services/common/send_log";
import * as neighbor from "../../../services/shift_monitoring/neighbors/map";
import { selectNeighbors } from "../../../services/shift_monitoring/neighbors/neighbors";
import {
    initMap,
    show,
    showGoCancels,
} from "../../../services/shift_monitoring/trips/map";
import { commonState } from "../../../store";
import { TripsState } from "../store";

interface Props {
    tripstate: TripsState;
    selectedTrip: SelectedTrip | null;
    permissions: Permission[];
    common: commonState;
    neighborsButtonAvailable?: boolean;
}

let g_trip_map;

const NeighborsButton: React.FC<Props> = (props: Props) => {
    let NButton = <Box></Box>;
    if (props.permissions.includes("neighbors")) {
        NButton = (
            <Button
                variant="contained"
                onClick={async (ev) => {
                    console.debug("selectedTrip:", props.selectedTrip);

                    const unladenTripSessionId =
                        props.selectedTrip && props.selectedTrip.tripSessionId
                            ? props.selectedTrip.tripSessionId
                            : "";

                    const unladenStartTs =
                        props.selectedTrip &&
                        props.selectedTrip.unladenStartTsRaw
                            ? props.selectedTrip.unladenStartTsRaw
                            : "";

                    const nb = await selectNeighbors(
                        unladenTripSessionId,
                        unladenStartTs
                    );

                    neighbor.show(g_trip_map, nb);
                    sendLog(
                        ResourceType.NEIGHBORS,
                        StatusType.GET_RESOURCE,
                        ActionType.NEIGHBORS
                    );
                }}
                color="info"
                size="small"
            >
                他車両実績表示
            </Button>
        );
    }
    return <Box> {NButton} </Box>;
};

const Header: React.FC<Props> = (props: Props) => {
    const _shiftdate = props.selectedTrip ? props.selectedTrip.shiftDate : "";
    // const _drivercode = props.tripstate ? props.tripstate.driverCode : "";
    const _drivercode = props.selectedTrip ? props.selectedTrip.driverCode : "";

    const _drivername = props.selectedTrip ? props.selectedTrip.driverName : "";
    const _unladenstart = props.selectedTrip
        ? props.selectedTrip.unladenStartTs
        : "";

    let _neighorsButtonAvailable = true;
    if (props.neighborsButtonAvailable !== undefined) {
        _neighorsButtonAvailable = props.neighborsButtonAvailable;
    }

    let NeighborsB = <Box />;
    if (_neighorsButtonAvailable) {
        NeighborsB = <NeighborsButton {...props} />;
    }

    return (
        <Box style={{ padding: "10px" }}>
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                <Box style={{ display: "flex" }}>
                    <Box style={{ padding: "20px" }}>{_shiftdate}</Box>
                    <Box style={{ padding: "20px" }}>
                        {_drivercode} {_drivername}
                    </Box>
                    <Box style={{ padding: "20px" }}>
                        空車開始時刻 {_unladenstart}
                    </Box>
                </Box>

                <Box
                    style={{
                        display: "flex",
                        alignItems: "center",
                        paddingRight: "40px",
                    }}
                >
                    {NeighborsB}
                    {/* <NeighborsButton {...props} /> */}
                </Box>
            </Box>
        </Box>
    );
};

export class TripsMap extends React.Component<Props> {
    constructor(props: any) {
        super(props);
    }

    mapContainer;

    componentDidMount = async (): Promise<any> => {
        await initMap(this.mapContainer).then((x) => {
            show(x, this.props.selectedTrip, false);

            g_trip_map = x;
        });
    };

    render = () => {
        console.debug("TRIPMAP SELECTED RECORD AND PROPS...", this.props);

        showGoCancels(g_trip_map);

        return (
            <Box
                id="Trips-Map-page-wrapper"
                sx={{
                    position: "static",
                    marginLeft: "30px",
                    width: "97%",
                }}
            >
                <HermesSnackbar
                    open={this.props.common.snackbarToggled}
                    msg={this.props.common.snackbarMsg}
                />
                <Header {...this.props} />
                <Box
                    id="Trips-Map-map-wrapper"
                    sx={{
                        display: "flex",
                        alignItems: "top",
                    }}
                >
                    <Box
                        id="Trips-Map-map-wrapper-inner"
                        sx={{
                            flexGrow: 2000,
                            left: "10px",
                            position: "relative",
                        }}
                    >
                        <Box
                            id="tripsMap"
                            sx={{
                                margin: "10px",
                                marginLeft: "15px",
                                minHeight: "800px",
                                width: "95%",
                                cursor: "pointer",
                            }}
                            ref={(el) => (this.mapContainer = el)}
                        />
                    </Box>
                </Box>
            </Box>
        );
    };
}
